<template>
  <aside class="automacao-editor__paleta">
    <p class="automacao-editor__coluna-titulo">Blocos</p>
    <p class="automacao-editor__coluna-ajuda">Abra uma categoria e arraste o item para o fluxo.</p>

    <div class="automacao-editor__paleta-lista">
      <section
        v-for="secao in secoes"
        :key="secao.id"
        class="automacao-editor__secao"
        :class="{ 'is-aberta': secaoEstaAberta(secao.id) }"
      >
        <button
          type="button"
          class="automacao-editor__secao-toggle"
          :aria-expanded="secaoEstaAberta(secao.id) ? 'true' : 'false'"
          @click="alternarSecao(secao.id)"
        >
          <span class="automacao-editor__secao-titulo">{{ secao.titulo }}</span>
          <span class="automacao-editor__secao-meta">{{ secao.itens.length }}</span>
          <i class="fas fa-chevron-down automacao-editor__secao-seta" aria-hidden="true"></i>
        </button>
        <div v-show="secaoEstaAberta(secao.id)" class="automacao-editor__secao-itens">
          <button
            v-for="item in secao.itens"
            :key="item.id"
            type="button"
            class="automacao-editor__bloco js-automacao-bloco"
            :class="[
              'automacao-editor__bloco--' + secao.id,
              { 'automacao-editor__bloco--indisponivel': !item.disponivel },
            ]"
            :draggable="item.disponivel"
            :disabled="!item.disponivel"
            :data-node="item.id"
            @dragstart="iniciarArraste($event, item.id, item.disponivel)"
          >
            <span class="automacao-editor__bloco-icone" aria-hidden="true">
              <i :class="item.icone"></i>
            </span>
            <span class="automacao-editor__bloco-texto">
              <strong>{{ item.titulo }}</strong>
            </span>
            <span v-if="!item.disponivel" class="automacao-editor__bloco-breve">Em breve</span>
          </button>
        </div>
      </section>
    </div>
  </aside>
</template>

<script>
import { secoesBlocos } from './automacao-blocos'

export default {
  name: 'AutomacaoPaleta',
  data() {
    return {
      abertas: {
        gatilho: true,
        condicao: false,
        acao: false,
      },
      secoes: secoesBlocos(),
    }
  },
  methods: {
    secaoEstaAberta(id) {
      return !!this.abertas[id]
    },
    alternarSecao(id) {
      this.$set(this.abertas, id, !this.abertas[id])
    },
    iniciarArraste(event, tipo, disponivel) {
      if (!disponivel) {
        event.preventDefault()
        return
      }
      event.dataTransfer.setData('node', tipo)
    },
  },
}
</script>
